export const SELECTS = {
  DEFAULT_OPTION_ID: 0,
}
